import { useNftx } from '@nftx/react';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../queryKeys';
import { Address } from 'nftx.js';

const useLiquidityPools = (
  {
    vaultId,
    vaultIds,
    poolIds,
    exists,
  }: {
    vaultId?: string;
    vaultIds?: string[];
    poolIds?: Address[];
    exists?: boolean;
  } = {},
  opts?: { enabled?: boolean }
) => {
  const {
    network,
    core: { fetchLiquidityPools },
  } = useNftx();

  return useQuery(
    [
      QueryKey.LIQUIDITY_POOLS,
      network,
      vaultId,
      `${vaultIds}`,
      `${poolIds}`,
      exists,
    ],
    async () =>
      fetchLiquidityPools({
        network,
        vaultIds,
        vaultId,
        poolIds,
        exists,
      }),
    opts
  );
};

export default useLiquidityPools;
